const getters = {
  // author: state => state.user.author
  // mId: state => state.stock.mId,
  // mac: state => state.macDetail.mac
  stockingIdList: state => state.stocking.stockingIdList,
  checkedGoodsList: state => state.goodsList.checkedGoodsList,
  searchGoodsObj: state => state.goodsList.searchGoodsObj,
  machineId: state => state.macDetail.machineId,
  machineCode: state => state.macDetail.machineCode,
  machineTypeId: state => state.macDetail.machineTypeId,
  updateGoodsParam: state => state.macDetail.updateGoodsParam,
  ctrlEnabled: state => state.macDetail.ctrlEnabled,
  lightCtrlEnabled: state => state.macDetail.lightCtrlEnabled,
  channelTest: state => state.macDetail.channelTest,
  updateChannelCapacity: state => state.macDetail.updateChannelCapacity,
  allMachine: state => state.machine.allMachine,
  faultMachine: state => state.machine.faultMachine,
  nostockMachine: state => state.machine.nostockMachine,
  outlineMachine: state => state.machine.outlineMachine,
  userInfo: state => state.machine.userInfo
};
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js